import { ICON_TYPES } from './iconTypes';

export default {
	person: {
		name: 'ios-person-circle-outline',
		type: ICON_TYPES.ionicon,
		text: 'Person',
	},
	people: {
		name: 'people-circle',
		type: ICON_TYPES.ionicon,
		text: 'People',
	},
	personAdd: {
		name: 'person-add',
		type: ICON_TYPES.ionicon,
		text: 'Create',
	},
	personInvite: {
		name: 'person-add',
		type: ICON_TYPES.materialIcons,
		text: 'Invite'
	},
	broken:{
		name: 'broken-image',
		type: ICON_TYPES.materialIcons,
		text: 'Broken',
	},
	circle: {
		name: 'circle',
		type: ICON_TYPES.fontAwesome,
		text: 'Circle',
	},
	dashboard: {
		name: 'pie-chart',
		type: ICON_TYPES.ionicon,
		text: 'Dashboard'
	},
	alert: {
		name: 'warning',
		type: ICON_TYPES.ionicon,
		text: 'Alert',
	},
	checkCircle: {
		name: 'check-circle',
		type: ICON_TYPES.fontAwesome,
		text: 'Check',
	},
	check: {
		name: 'check',
		type: ICON_TYPES.fontAwesome,
		text: 'Check',
	},
	teamAdd: {
		name: 'group-add',
		type: ICON_TYPES.materialIcons,
		text: 'Add Team'
	},
	config: {
		name: 'settings',
		type: ICON_TYPES.ionicon,
		text: 'Config'
	},
	loading: {
		name: 'spinner',
		type: ICON_TYPES.fontAwesome,
		text: 'Loading',
	}
};